<template>
  <v-layout
    column
    wrap
  >
    <transition
      :enter-active-class="transitionEnterClass"
      :leave-active-class="transitionLeaveClass"
      name="fade"
      mode="out-in"
    >
      <keep-alive include="VisitorTypes">
        <v-container
          grid-list-md
          fluid
          class="pa-2"
        >
          <router-view :key="$route.path" />
        </v-container>
      </keep-alive>
    </transition>
  </v-layout>
</template>


<script>
import pageTransitionMixin from '@/mixins/page-transition-mixin';

export default {
  name: 'CheckinFlow',
  mixins: [pageTransitionMixin],
  data() {
    return {};
  },
  beforeRouteUpdate(to, from, next) {
    this.updatePageTransition(to, from);
    next();
  },
  created() {
    this.$store.commit('setToolbarTitle', {
      toolbarTitle: 'Checkin Flow Settings'
    });
  }
};
</script>
